/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import * as React from "react"
import {
  createConnector,
  SearchState,
  SearchResults,
  SearchParameters
} from "react-instantsearch-dom"

export interface QueryAndHitsProps<THit> {
  refine: (nextRefinement: string) => void
  query: string
  hits: THit[]
}

interface Props {
  initialQuery?: string
}

type ProvidedProps<THit> = QueryAndHitsProps<THit> & { props: Props }

interface Results<THit> {
  results?: SearchResults<THit>
}

const getHits = <THit>(searchResults: Results<THit> = {}) =>
  searchResults.results && searchResults.results.hits
    ? searchResults.results.hits
    : []

const getQuery = ({ initialQuery }: Props, { query }: SearchState) =>
  query !== undefined ? query : initialQuery ? initialQuery : ""

const createQueryAndHitsConnector = <THit>(hitsPerPage: number) =>
  createConnector({
    displayName: "AlgoliaQueryAndHits",

    getProvidedProps: (
      props: Props,
      searchState: SearchState,
      searchResults: Results<THit>
    ) => ({
      props,
      query: getQuery(props, searchState),
      hits: getHits(searchResults)
    }),

    refine: (_: Props, searchState: SearchState, nextRefinement: string) => ({
      ...searchState,
      query: nextRefinement
    }),

    getSearchParameters: (
      params: SearchParameters,
      _: Props,
      state: SearchState
    ) => params.setQuery(state.query).setHitsPerPage(hitsPerPage)
  })

export const connectQueryAndHits =
  <THit>(maxHits: number) =>
  (Component: React.ComponentClass<Props & QueryAndHitsProps<THit>>) =>
    createQueryAndHitsConnector<THit>(maxHits)(
      ({ hits, refine, query, props }: ProvidedProps<THit>) =>
        React.createElement(Component, {
          ...props,
          query,
          refine,
          hits
        })
    )
